import React from "react";
import about from "../about.jpg";
import me from "../me.jpg";
import Resume from "../Resume.pdf";

export default function About() {
    return (
        <main className="about-root">
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Sora:wght@700;800&display=swap');

        .about-root {
          min-height: 100vh;
          background-color: #080e1c;
          font-family: 'Inter', system-ui, sans-serif;
          position: relative;
          overflow: hidden;
        }

        /* Subtle background texture */
        .about-root::before {
          content: '';
          position: fixed;
          inset: 0;
          background:
            radial-gradient(ellipse 80% 50% at 20% 10%, rgba(99,102,241,0.12) 0%, transparent 60%),
            radial-gradient(ellipse 60% 40% at 80% 80%, rgba(56,189,248,0.07) 0%, transparent 55%);
          pointer-events: none;
          z-index: 0;
        }

        .hero-banner {
          position: relative;
          height: 280px;
          overflow: hidden;
        }

        .hero-banner img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(0.25) saturate(0.6);
        }

        .hero-banner::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, transparent 30%, #080e1c 100%);
        }

        .container {
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 2rem 5rem;
          position: relative;
          z-index: 1;
        }

        /* Gradient border card */
        .card-wrapper {
          position: relative;
          border-radius: 20px;
          padding: 2px;
          background: linear-gradient(135deg, #6366f1, #38bdf8, #818cf8, #6366f1);
          background-size: 300% 300%;
          animation: gradientShift 6s ease infinite;
          margin-top: -80px;
          box-shadow: 0 40px 80px rgba(0,0,0,0.6), 0 0 60px rgba(99,102,241,0.15);
        }

        @keyframes gradientShift {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .card {
          background: #0f1829;
          border-radius: 18px;
          padding: 3rem 3.5rem;
          display: flex;
          gap: 3.5rem;
          align-items: flex-start;
        }

        @media (max-width: 768px) {
          .card {
            flex-direction: column;
            align-items: center;
            padding: 2.5rem 1.75rem;
            gap: 2rem;
          }
          .hero-banner { height: 180px; }
          .about-name { font-size: 2.4rem !important; }
        }

        /* Photo */
        .photo-col {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.5rem;
        }

        .photo-ring {
          position: relative;
          border-radius: 50%;
          padding: 3px;
          background: linear-gradient(135deg, #6366f1, #38bdf8);
          flex-shrink: 0;
        }

        .photo-ring img {
          width: 180px;
          height: 180px;
          border-radius: 50%;
          object-fit: cover;
          object-position: top;
          display: block;
          border: 3px solid #0f1829;
        }

        .status-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(99,102,241,0.12);
          border: 1px solid rgba(99,102,241,0.3);
          border-radius: 100px;
          padding: 0.35rem 0.85rem;
          font-size: 0.72rem;
          font-weight: 500;
          color: #a5b4fc;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          white-space: nowrap;
        }

        .status-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #4ade80;
          animation: pulse 2s ease infinite;
          flex-shrink: 0;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.6; transform: scale(0.85); }
        }

        /* Content */
        .content-col {
          flex: 1;
          min-width: 0;
        }

        .about-greeting {
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #6366f1;
          margin-bottom: 0.6rem;
        }

        .about-name {
          font-family: 'Sora', system-ui, sans-serif;
          font-size: 3.2rem;
          font-weight: 800;
          line-height: 1.05;
          margin-bottom: 0.5rem;
          color: #f0f4ff;
          letter-spacing: -0.02em;
        }

        .about-name span {
          background: linear-gradient(90deg, #818cf8, #38bdf8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .name-underline {
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, #6366f1, #38bdf8);
          border-radius: 2px;
          margin-bottom: 1.8rem;
        }

        .about-bio {
          color: #94a3b8;
          font-size: 0.975rem;
          line-height: 1.85;
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .about-bio p {
          margin: 0;
        }

        /* Tech pills */
        .tech-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 2rem;
        }

        .tech-pill {
          background: rgba(99,102,241,0.1);
          border: 1px solid rgba(99,102,241,0.2);
          color: #a5b4fc;
          font-size: 0.72rem;
          font-weight: 500;
          padding: 0.3rem 0.7rem;
          border-radius: 6px;
          letter-spacing: 0.02em;
        }

        /* CTA */
        .cta-row {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
          align-items: center;
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: linear-gradient(135deg, #6366f1, #818cf8);
          color: #fff;
          font-weight: 600;
          font-size: 0.875rem;
          padding: 0.75rem 1.5rem;
          border-radius: 10px;
          text-decoration: none;
          transition: opacity 0.2s, transform 0.2s;
          box-shadow: 0 4px 20px rgba(99,102,241,0.35);
        }

        .btn-primary:hover {
          opacity: 0.88;
          transform: translateY(-1px);
        }

        .btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: transparent;
          color: #94a3b8;
          font-weight: 500;
          font-size: 0.875rem;
          padding: 0.75rem 1.25rem;
          border-radius: 10px;
          text-decoration: none;
          border: 1px solid rgba(148,163,184,0.2);
          transition: color 0.2s, border-color 0.2s;
        }

        .btn-secondary:hover {
          color: #f0f4ff;
          border-color: rgba(148,163,184,0.5);
        }
      `}</style>

            {/* Hero banner image */}
            <div className="hero-banner">
                <img src={about} alt="" aria-hidden="true" />
            </div>

            <div className="container">
                <div className="card-wrapper">
                    <div className="card">

                        {/* Left — photo */}
                        <div className="photo-col">
                            <div className="photo-ring">
                                <img src={me} alt="Rashi Agrawal" />
                            </div>
                            <div className="status-badge">
                                <span className="status-dot" />
                                Open to work
                            </div>
                        </div>

                        {/* Right — content */}
                        <div className="content-col">
                            <p className="about-greeting">Software Engineer · Melbourne</p>
                            <h1 className="about-name">
                                Hey, I'm{" "}
                                <span>Rashi Agrawal</span>
                            </h1>
                            <div className="name-underline" />

                            <div className="about-bio">
                                <p>
                                    I'm a software engineer based in Melbourne with 3+ years of commercial experience
                                    across the full stack. I've worked on e-commerce platforms handling thousands of
                                    daily orders, web hosting infrastructure serving multiple clients, open-source
                                    university platforms, mobile applications, and everything in between. The variety
                                    is intentional — I genuinely enjoy picking up new problems in new contexts.
                                </p>
                                <p>
                                    On the technical side, my work spans Python, Ruby on Rails, JavaScript, TypeScript,
                                    and ReactJS on the frontend, with PostgreSQL, MySQL, and AWS infrastructure
                                    underneath. I've designed RESTful APIs, built system integrations, modernised
                                    legacy codebases, and deployed production systems with monitoring, alerting, and
                                    CI/CD pipelines built in. I'm comfortable across the stack and not precious about
                                    which layer I'm working on.
                                </p>
                                <p>
                                    I've started weaving AI tools into my day-to-day work — Claude and Cursor for
                                    coding, debugging, and problem solving. It's not something I lead with, but it's
                                    genuinely changed how I work, and I've gotten comfortable knowing when to reach
                                    for it and when not to.
                                </p>
                                <p>
                                    What I care about most is writing code that actually holds up — clean, tested, and
                                    maintainable enough that the next person (or future me) isn't left guessing. I
                                    hold a Bachelor of Technology in Computer Science and have recently completed a
                                    Master of IT at Deakin University.
                                </p>
                                <p>
                                    Outside of work, I'm usually meeting new people, exploring Melbourne, or finding
                                    something completely new to learn. That curiosity tends to follow me into
                                    everything I do.
                                </p>
                            </div>

                            {/* Tech pills */}
                            <div className="tech-row">
                                {["Python", "Ruby on Rails", "C", "C++", "JavaScript", "ReactJS", "Node.js", "TypeScript", "Django", "PostgreSQL", "MySQL", "MongoDB", "AWS", "Docker", "Kubernetes", "Git", "CI/CD", "REST APIs", "Linux", "Prometheus", "Grafana", "Sidekiq"].map(t => (
                                    <span key={t} className="tech-pill">{t}</span>
                                ))}
                            </div>

                            {/* CTAs */}
                            <div className="cta-row">
                                <a href={Resume} target="_blank" rel="noreferrer" className="btn-primary">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
                                    </svg>
                                    View Resume
                                </a>
                                <a href="mailto:rashiagrawal299@gmail.com" className="btn-secondary">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,12 2,6" />
                                    </svg>
                                    Get in touch
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    );
}